export default __webpack_public_path__ + "static/media/Baz_Bahadur_Palace_-_Inside.abed8324.jpg";